import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Landing } from './pages/Landing';
import { Webinar } from './pages/Webinar';
interface AppProps {
  webinarUrl?: string;
  whatsappGroupUrl?: string;
  youtubeUrl?: string;
  instagramUrl?: string;
}
export function App({
  webinarUrl = '/webinar',
  whatsappGroupUrl = 'https://chat.whatsapp.com/EU8yo9Ah92zAL9SU6MFan9?s=cl&p=i&mlu=0&ilr=4',
  youtubeUrl = 'https://youtube.com/@soyfreddypimentel',
  instagramUrl = 'https://www.instagram.com/soyfreddypimentel'
}: AppProps) {
  return <BrowserRouter data-id="element-0" data-mp="2mjpyfm36lqiz">
      <Routes data-id="element-1" data-mp="31agn4l9h89hv">
        <Route path="/" element={<Landing webinarUrl={webinarUrl} youtubeUrl={youtubeUrl} instagramUrl={instagramUrl} data-id="element-3" data-mp="31ctf7r8y808n" />} data-id="element-2" data-mp="31b8gdpflpv4z" />
        <Route path="/webinar" element={<Webinar whatsappGroupUrl={whatsappGroupUrl} data-id="element-5" data-mp="28s2y9b64bxux" />} data-id="element-4" data-mp="28t4jg8gum0qd" />
      </Routes>
    </BrowserRouter>;
}